export default function SongIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.1533 3.50781C19.9097 3.58461 20.5 4.22334 20.5 5V7.5C20.5 8.32843 19.8284 9 19 9H12.2764L14.292 13.4355C14.741 14.1855 15 15.0623 15 16C15 18.7614 12.7614 21 10 21C7.23858 21 5 18.7614 5 16C5 13.2386 7.23858 11 10 11C10.8514 11 11.6528 11.2135 12.3545 11.5889L11.0449 8.70703L11.043 8.70312L9.66797 5.60938C9.22711 4.61744 9.95357 3.5 11.0391 3.5H19L19.1533 3.50781ZM10 12C7.79086 12 6 13.7909 6 16C6 18.2091 7.79086 20 10 20C12.2091 20 14 18.2091 14 16C14 15.3505 13.8441 14.7376 13.5693 14.1953L13.5449 14.207L13.4072 13.9053C12.7031 12.7624 11.4409 12 10 12ZM11.0391 4.5C10.6772 4.5 10.4351 4.87248 10.582 5.20312L11.8252 8H19C19.2761 8 19.5 7.77614 19.5 7.5V5C19.5 4.75829 19.3286 4.55629 19.1006 4.50977L19 4.5H11.0391Z"
          fill="white"
        />
      </svg>
    </>
  );
}
